import React, { useState } from "react";
import {
  Modal,
  Card,
  CardContent,
  Button,
  Grid,
  FormControl,
  TextField,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import { styleEndowment } from "./styleEndowment";
import { Controller } from 'react-hook-form';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const GenerateCardFormat = ({
    openCard,
    closeModalCard,
    maestras,
    onSubmit,
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    getValues,
    dataCardFormat,
    isDisabledBtnCard
}) => {
    const classes = styleEndowment();
    const [modalStyle] = useState(getModalStyle);

    const cleanForm = () => {
        setValue('name', '');
        setValue('document', '');
        setValue('documentType', '');
        setValue('deliverDate', '');
        setValue('linkageType', '');
        closeModalCard();
    }

    const handleUserKeyPressDocumento = (e) => {
        var form = getValues();
        if (form.documentType !== "PP" && form.documentType !== "CE") {
          let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
          if (!validChars.includes(e.key)) {
            e.preventDefault();
          }
        }
    };
  
    const bodyModal = (
      <div style={modalStyle} className={classes.contModalDownload}>
        <Card className={classes.card} elevation={0} >
        <CardContent className={classes.bodyModal}>

          <div className={classes.contAccordion}>
            <p style={{textAlign: 'center', fontSize: 20}}>
                Entrega de carnet y portacarnet
            </p>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>

                    <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                            variant="outlined"
                            fullWidth
                            size="small"
                            error={
                                !!errors.hasOwnProperty("name") &&
                                errors["name"].message
                            }
                        >
                        <Controller
                            name="name"
                            control={control}
                            defaultValue={dataCardFormat?.employee?.fullName}
                            rules={{ required: true }}
                            render={({ field }) => (
                            <TextField
                                {...field}
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                name="name"
                                label="Nombre *"
                                variant="outlined"
                                disabled={true}
                                defaultValue={dataCardFormat?.employee?.fullName}
                                margin="dense"
                                size="small"
                                inputRef={register}
                                fullWidth
                                className={classes.inputFormDisabled}
                                error={
                                errors.hasOwnProperty("name") &&
                                errors["name"].message
                                }
                            />
                            )}
                        />
                        <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                            {errors.hasOwnProperty("name") && errors["name"].message}
                        </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.inputFormDisabled}
                            size="small"
                            error={
                            !!errors.hasOwnProperty("documentType") &&
                            errors["documentType"].message
                            }
                        >
                            <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                                Tipo de documento *
                            </InputLabel>
                            <Controller
                                fullWidth
                                control={control}
                                name="documentType"
                                disabled={true}
                                inputRef={register}
                                defaultValue={dataCardFormat?.employee?.documentType}
                                className={classes.inputFormDisabled}
                                label="Tipo de documento *"
                                size="small"
                                notched={true}
                                inputProps={{
                                    name: "documentType",
                                    id: "outlined-select-documentType",
                                }}
                                as={
                                    <Select>
                                        {maestras?.tipoDocumnetoIdentificacion?.map((res) => (
                                                <MenuItem
                                                    className={classes.menuItem}
                                                    key={res?.key}
                                                    value={res?.key}
                                                >
                                                    {res?.value}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                }
                            />
                            <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                                {errors.hasOwnProperty("documentType") && errors["documentType"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <FormControl fullWidth> 
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                inputRef={register}
                                type="text"
                                name="document"
                                defaultValue={dataCardFormat?.employee?.document}
                                className={classes.inputFormDisabled}
                                label="Número Documento *"
                                variant="outlined"
                                fullWidth
                                disabled={true}
                                size="small"
                                error={errors.hasOwnProperty('document') && errors['document'].message}
                                onKeyPress={handleUserKeyPressDocumento }
                            />
                            <FormHelperText style={{color: "#f44336", paddingLeft: 14}} >
                                {errors.hasOwnProperty('document') && errors['document'].message}                          
                            </FormHelperText> 
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                        <Controller
                            control={control}
                            name="deliverDate"
                            placeholder="dd/mm/yyyy"
                            size="small"
                            defaultValue={null}
                            as={
                            <KeyboardDatePicker
                                fullWidth
                                inputRef={register}
                                inputVariant="outlined"
                                variant="inline"
                                format="dd/MM/yyyy"
                                className={classes.inputForm}
                                label="Fecha de entrega *"
                                InputLabelProps={{ shrink: true }}
                                error={!!errors.hasOwnProperty("deliverDate") && errors["deliverDate"].message}
                                helperText={errors.hasOwnProperty("deliverDate") && errors["deliverDate"].message }
                                minDate={new Date()}
                                minDateMessage={"No puede ser menor a la fecha actual"}
                            />
                            }
                        />
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.inputForm}
                            size="small"
                            error={
                            !!errors.hasOwnProperty("linkageType") &&
                            errors["linkageType"].message
                            }
                        >
                            <InputLabel htmlFor="outlined-select-linkageType" shrink={true}>
                                Tipo de vinculación *
                            </InputLabel>
                            <Controller
                                fullWidth
                                control={control}
                                name="linkageType"
                                inputRef={register}
                                defaultValue=''
                                className={classes.inputForm}
                                label="Tipo de vinculación *"
                                size="small"
                                notched={true}
                                inputProps={{
                                    name: "linkageType",
                                    id: "outlined-select-linkageType",
                                }}
                                as={
                                    <Select>
                                        <MenuItem
                                            className={classes.menuItem}
                                            key='contratista'
                                            value='contratista'
                                        >
                                            Contratista
                                        </MenuItem>
                                        <MenuItem
                                            className={classes.menuItem}
                                            key='nomina'
                                            value='nomina'
                                        >
                                            Nómina
                                        </MenuItem>
                                    </Select>
                                }
                            />
                            <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                                {errors.hasOwnProperty("linkageType") && errors["linkageType"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12} style={{textAlign: 'center'}}>
                        <Button
                            variant='outlined'
                            style={{backgroundColor: 'transparent', color: '#7EBDCE'}}
                            onClick={cleanForm}
                        >
                            Cancelar
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                            type='submit'
                            variant='contained'
                            className={classes.buttonContinue}
                            disabled={isDisabledBtnCard}
                        >
                            Aceptar
                        </Button>
                    </Grid>

                </Grid>  
            </form>
          </div>
       </CardContent>
      </Card>
      </div>
    );
  
    return (
      <div>
        <Modal
          open={openCard}
        >
          {bodyModal}
        </Modal>
      </div>
    );
}

export default GenerateCardFormat;